import HttpClient from "@/common/boot/HttpClient"

const listarSubModulos = async ({ commit }, payload) => {
  commit('CARREGANDO', true);
  
  await HttpClient.get('/app/submodulos', payload).then(response => {
      commit('LISTAR_DADOS', response.data.data);
      return response;
  }).finally( () => {
    commit('CARREGANDO', false);
  });
}

const excluirSubModulos = async ({ dispatch },  payload) => { 
    let qtdRows = payload.length;
    for(let i=0;i<qtdRows;++i){
      await excluir(payload[i]);
    }
    dispatch('listarSubModulos');
}  

const excluir = async(linha) => {
  const resp = await HttpClient.delete(`/app/submodulos/${linha.id}`).then(response => { return response; });
  return resp;
}

const salvarSubModulo = async ({ commit,dispatch }, payload) => {

  commit('CARREGANDO', true);

  return await HttpClient.post('/app/submodulos', payload).then(response => {
    dispatch('listarSubModulos');
    return response;
  })
  .finally( () => {
    commit('CARREGANDO', false);
  });
}

const recuperarSubModulo = ({ commit, state }, payload) => {

  const item = state.items.filter(item => item.id === payload.id);

  if(item.length) {
    commit('INSERIR_SUBMODULO_SELECIONADO', ...item);
    return true;
  }

  return false;
}

const atualizarSubModulo = async ({ commit,dispatch }, payload) => {
  commit('CARREGANDO', true);

  return await HttpClient.put(`/app/submodulos/${payload.id}`, payload).then(response => {
    dispatch('listarSubModulos');
    return response;
  })
  .finally( () => {
    commit('CARREGANDO', false);
  })
}

export {
  listarSubModulos,
  excluirSubModulos,
  salvarSubModulo,
  recuperarSubModulo,
  atualizarSubModulo
}